import React from "react";
import { X } from "lucide-react";
import "../styles/sizeGuide.css"; // (optionnel, pour la mise en page)

const SizeGuide = ({ isOpen, onClose, imageUrl }) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    // ferme la popup en cliquant sur le fond
    onClose();
  };

  const handleContentClick = (e) => {
    // empêche la fermeture en cliquant sur le contenu
    e.stopPropagation();
  };

  return (
    <div className="popup-backdrop" onClick={handleBackdropClick}>
      <div className="popup-content" onClick={handleContentClick}>
        <button className="popup-close-btn" onClick={onClose}>
          <X size={24} />
        </button>
        <img src={imageUrl} alt="Preview" className="popup-image" />
      </div>
    </div>
  );
};

export default SizeGuide;
